import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 85vh;

  .archive-body {
    overflow-y: auto;
    color: ${(props) => props.theme.$gray900};
  }

  .archive-body p:last-of-type {
    margin-bottom: 0;
  }
`;
